<i18n>
{
  "en": {
    "areu18": "Are you 18+ years old?",
    "warning": "",
    "yes_button": "YES, I am",
    "no_button": "NO, I am not"
  },
  "ja": {
    "areu18": "あなたは18歳以上ですか？",
    "warning": "",
    "yes_button": "はい (入場する)",
    "no_button": "いいえ"
  }
}
</i18n>

<template>
<modal class="dl-modal dl-modal--agecheck" name="ui-modal-agecheck" :draggable="false" :clickToClose="false">
  <div class="agecheck">
    <div class="agecheck-brand">
      <img :src="(locale === 'en') ? '/img/common/mura-logo-en.svg' : '/img/common/mura-logo.svg'" alt="muramura.tv">
    </div>
    <div class="agecheck-verification">Are you 18+ years old?</div>
    <div class="agecheck-cta">
      <div class="enter">
        <button class="enter-jp enter-button" :value="$t('yes_button')" @click="closeModal()">はい<span>(日本語入口)</span></button>
        <span class="enter-notation">18歳以上の方のみご入場ください</span>
      </div>
      <div class="enter">
        <button class="enter-en enter-button" :value="$t('yes_button')" @click="closeModal('en')">YES, I am</button>
        <span class="enter-notation">You must be over 18</span>
      </div>
    </div>
    <div class="agecheck-disclaimer">
      <p>You have reached an adult only area. If you are under 18 or age of legal majority in the jurisdiction in which you reside or access this website, whichever is older, you must <a href="http://www.yahoo.com">leave</a> immediately.</p>
      <p><b>Parents!</b>&nbsp;<a href="https://www.d2pass.com/hogosha_eng">Click here</a> to block this website with parental controls. This website contains (sexually explicit) content of an adult-oriented nature inappropriate for those under the age of 18.</p>
      <p>ADULT CONTENT WARNING: Do not enter this website (the "Website") unless you are at least 18 years of age (or age of legal majority in the jurisdiction in which you reside or access this site, whichever is older) By entering this Website, you understand and agree to the terms of the following agreement. You affirm that you are an adult, at least 18 years of age (or the age of legal majority in the jurisdiction in which you reside and/or use the Website, whichever is older). You understand and agree that, by accepting the terms of this Agreement, you will hold the Website, its affiliates, successors, assigns and licensees harmless from and against any responsibilities and liabilities related to your requesting, receiving or possessing materials contained herein. You understand that when you gain access to the Website, you will be exposed to visual images, verbal descriptions and audio sounds of a sexually oriented, frankly erotic nature, which may include graphic visual depictions and descriptions of nudity and sexual activity. You are voluntarily choosing to do so and you are familiar with the standards and/or laws of the community in which you use the Website regarding the acceptance of such sexually oriented materials, and the materials you expect to encounter are within those standards and permitted by the applicable laws. Especially if the laws of the community from which you access or use the Website so require or prohibit streaming or downloading certain material, you understand such requirements and prohibition and warrant that you comply with the applicable laws. If you use the Website from Japan regardless of your residence, you understand, agree and warrant that you are not allowed to and shall not download any material from the Website that is prohibited by the laws of Japan, including any material displaying private parts without any mosaic or other similar material covering the same. If any term of this agreement is declared or found to be illegal, unenforceable or void by a court of the competent jurisdiction, the remaining terms of the Agreement shall be severable and remain in full force and effect. This agreement comprises the entire agreement between the Website and you, superseding any prior agreements between you and the Website with respect to its subject matter.</p>
      <p>当サイトにはアダルトコンテンツが含まれています。このページを閲覧する条件として、ユーザーは下記規約に同意します。ユーザーは18歳以上または居住もしくは当サイトを利用する司法管轄地における成人年齢のいずれか高い方に達している成人であることを宣誓します。ユーザーは、本同意書の規約に同意することにより、ユーザーによる閲覧コンテンツ請求、受領、または保持に関連する責任については、当サイトおよびその後継人、譲渡人、ならびにライセンシーを防御しなければならないことことを理解し、合意します。ユーザーは、は当サイトにアクセスすることにより、ヌードや性行為を含む性的画像、口頭描写、および音声を含むコンテンツに自主的な選択でさらされることとなります。ユーザーは、当サイトを利用する地域社会における風俗関連のメディアに関する法律およびその他の法的な制限を理解し、当サイトのコンテンツがかかる法律およびその他の法的な制限の許容範囲内であることを表明および保証します。ユーザーは、当サイトを利用する地域の法律によってはストリーミングやダウンロードが禁止されるコンテンツがあり、その場合はかかる法律を遵守することを保証します。特に日本から当サイトを利用する場合はユーザーの居住地が日本でなくても、性器をモザイクまたはその他の方法で閲覧できないようにすることが法律上要求されることを理解し、ユーザーが日本国内において違法とされるコンテンツをダウンロードする行為は禁止されていることを理解し、該当する場合には禁止されているコンテンツをダウンロードしないことを保証します。管轄を有する裁判所によって本同意書内の規約が違法、法的強制不可能、または無効と判断された場合でも、それ以外の本同意書の規約は有効なまま存続します。本同意書は、本同意書の目的に関して当サイトとユーザーの間のの完全な合意事項を含み、過去の全ての合意事項に優先することを理解し、同意します。</p>
    </div>
  </div>
</modal>
</template>

<script>
/* eslint max-len: 0 */
import Cookies from 'js-cookie';
import APP_CONFIG from '@/appConfig';
import EventBus from '@/assets/js/utils/EventBus';

const COOKIE_NAME = 'ageCheck';

export default {
  props: {
    exitUrl: {
      type: String,
      default: 'https://www.yahoo.com',
    },
    englishUrl: {
      type: String,
      default: 'https://en.muramura.tv',
    },
  },
  mounted() {
    this.$router.onReady(() => {
      // only show the age check modal on the initial hit and only if it's on the home page,
      // unless overrides are set (via ?agecheck query param to suppress the display or force it on)
      const suppressAgeCheck = (Object.prototype.hasOwnProperty.call(this.$route.query, 'agecheck')
        && (this.$route.query.agecheck === '0'
          || this.$route.query.agecheck === 'no'
          || this.$route.query.agecheck === 'off'
          || this.$route.query.agecheck === 'false'));

      const forceAgeCheck = (Object.prototype.hasOwnProperty.call(this.$route.query, 'agecheck')
        && (this.$route.query.agecheck === '1'
          || this.$route.query.agecheck === 'yes'
          || this.$route.query.agecheck === 'on'
          || this.$route.query.agecheck === 'true'));

      const hasCookie = Cookies.get(COOKIE_NAME);

      if ((this.$route.name === 'home' && !suppressAgeCheck && !hasCookie) || forceAgeCheck) {
        this.$modal.show('ui-modal-agecheck');
      }
    });
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    closeModal(locale) {
      this.$modal.hide('ui-modal-agecheck');

      // set 7-day cookie so we don't show it for a week after clicking Yes
      Cookies.set(COOKIE_NAME, 1, { expires: 7, domain: APP_CONFIG.site.domain });

      // Emit event to notify other components that age verification has been acknowledged
      EventBus.$emit('agecheck:acknowledged');

      if (locale === 'en') window.location.href = this.englishUrl;
    },
    gtfo() {
      this.$analytics.trackEvent('Age Verification', 'No Button');
      window.location.href = this.exitUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
